"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PhoneCallSquare = function PhoneCallSquare(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("rect", {
    width: "25",
    height: "25",
    fill: props.backgroundColor
  }), _react.default.createElement("g", {
    opacity: "0.5"
  }, _react.default.createElement("path", {
    opacity: "0.5",
    d: "M17.566 5.62158H12.5938H7.62158V20.5382H12.5938H17.566V10.5938V5.62158Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    opacity: "0.5",
    d: "M17.566 21.1597H7.62153C7.45669 21.1597 7.2986 21.0942 7.18204 20.9777C7.06548 20.8611 7 20.703 7 20.5382V5.62153C7 5.45669 7.06548 5.2986 7.18204 5.18204C7.2986 5.06548 7.45669 5 7.62153 5H17.566C17.7308 5 17.8889 5.06548 18.0055 5.18204C18.122 5.2986 18.1875 5.45669 18.1875 5.62153V20.5382C18.1875 20.703 18.122 20.8611 18.0055 20.9777C17.8889 21.0942 17.7308 21.1597 17.566 21.1597ZM8.24306 19.9167H16.9444V6.24306H8.24306V19.9167Z",
    fill: props.foregroundColor
  })), _react.default.createElement("path", {
    d: "M13.1109 15.4059L13.6853 14.8315C13.7622 14.7546 13.8599 14.7019 13.9664 14.6801C14.073 14.6582 14.1836 14.668 14.2845 14.7084L14.984 14.9884C15.0871 15.0297 15.1755 15.1009 15.2378 15.1928C15.3 15.2848 15.3333 15.3933 15.3333 15.5043V16.7764C15.3335 16.852 15.3182 16.9269 15.2885 16.9964C15.2587 17.0659 15.2151 17.1286 15.1603 17.1807C15.1054 17.2327 15.0406 17.2731 14.9696 17.2992C14.8987 17.3253 14.8231 17.3367 14.7476 17.3326C9.84437 17.0275 8.85408 12.8745 8.67023 11.2842C8.66132 11.2065 8.66898 11.1277 8.69269 11.0531C8.71641 10.9786 8.75564 10.9098 8.80781 10.8515C8.85999 10.7932 8.92392 10.7466 8.9954 10.7147C9.06688 10.6829 9.1443 10.6665 9.22255 10.6668H10.4721C10.5831 10.6667 10.6916 10.7 10.7836 10.7623C10.8756 10.8245 10.9468 10.9129 10.988 11.016L11.2678 11.7155C11.3081 11.8165 11.318 11.9271 11.2961 12.0336C11.2742 12.1401 11.2216 12.2379 11.1447 12.3148L10.5703 12.8891C10.5703 12.8891 10.8888 15.1282 13.1109 15.4059Z",
    fill: props.foregroundColor,
    "fill-opacity": "0.5"
  }), _react.default.createElement("path", {
    d: "M14.5238 12.5771C14.5445 13.0412 13.8221 13.0069 13.8235 12.6075C13.825 12.2081 13.6888 12.0669 13.4833 11.8785C13.2779 11.6902 12.9663 11.6656 12.7276 11.6028C12.4888 11.54 12.233 10.9222 12.6971 10.9026C13.1613 10.883 13.5707 11.0084 13.9567 11.3622C14.3426 11.716 14.503 12.113 14.5238 12.5771Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M16.2745 12.5012C16.3158 13.4294 15.5286 13.2569 15.4965 12.535C15.4643 11.8131 15.2147 11.1955 14.6143 10.6451C14.0139 10.0947 13.377 9.89968 12.655 9.93023C11.933 9.96078 11.6929 9.19151 12.6212 9.15221C13.5495 9.1129 14.4555 9.44342 15.1404 10.0713C15.8252 10.6991 16.2331 11.573 16.2745 12.5012Z",
    fill: props.foregroundColor
  }));
};

PhoneCallSquare.defaultProps = {
  altText: "Phone Call Square",
  backgroundColor: "#2D5AB4",
  foregroundColor: "#FFFFFF"
};
PhoneCallSquare.propTypes = {
  altText: _propTypes.default.string,
  backgroundColor: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = PhoneCallSquare;
exports.default = _default;